import { useEffect, useState } from 'react';
import { axiosInstance } from './axios';
export const getAnalytics = (path, params, signal) => axiosInstance.get(`/v1/admin-page/analytics/${path}`, {
  params,
  signal
}).then(r => r.data);
export function useAnalytics(path, params = {}, enabled = true) {
  const key = JSON.stringify(params);
  const [result, setResult] = useState({
    data: null,
    loading: true,
    error: null
  });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    setResult({
      data: null,
      loading: true,
      error: null
    });
    getAnalytics(path, JSON.parse(key), controller.signal).then(value => {
      if (!controller.signal.aborted) setResult({
        ...value,
        loading: false,
        error: null
      });
    }).catch(error => {
      if (!controller.signal.aborted) setResult({
        data: null,
        loading: false,
        error: error.response?.data?.detail || '분석 데이터를 불러오지 못했습니다.'
      });
    });
    return () => controller.abort();
  }, [path, key, enabled, attempt]);
  return {
    ...result,
    retry: () => setAttempt(n => n + 1)
  };
}
export function analyticsParams(filters, options, channel = filters.channel) {
  const period = options?.signup_periods.find(p => p.id === filters.period);
  return {
    signup_from: period?.from || undefined,
    signup_to: period?.to || undefined,
    observation_days: filters.window,
    as_of: options?.latest_as_of,
    service: options?.services.find(s => s.label === filters.service)?.id || 'all',
    channel: options?.channels.find(c => c.label === channel)?.id || 'all'
  };
}
export function displayMember(m, options) {
  return {
    ...m,
    joined: new Intl.DateTimeFormat('sv-SE', {timeZone: 'Asia/Seoul'}).format(new Date(m.joined_at)),
    channel: options.channels.find(c => c.id === m.signup_channel)?.label || m.signup_channel,
    service: options.services.find(s => s.id === m.signup_interest_service)?.label || '미응답',
    reported: m.reported_source || '미응답',
    state: options.behavior_states.find(s => s.id === m.behavior_state)?.label || m.behavior_state
  };
}
